package com.devi3east.bashbuddy.dashboard.results

import kotlinx.serialization.Serializable

@Serializable
data class DeleteResult(
    val success: Boolean,
    val message: String? = null
)